import { formatUsd } from 'shared';
import { cartLines } from '@/state/pricing.js';
import { paymentTermsLabel } from '@/lib/formatters.js';

/** Shared by the header cart and the summary card, so the order never reads two ways. */
export function OutreachOrderLines() {
  return (
    <div className="sm-stack sm-summary-list">
      {cartLines.value.map((line) => (
        <div className="sm-stack sm-summary-item" key={line.entry.quoteItemId}>
          <div className="sm-summary-item-head">
            <div className="sm-stack sm-pair">
              <p className="sm-type-body-strong">{line.tier.product_name}</p>
              <p className="sm-type-caption">{line.tier.term_months} mo coverage</p>
            </div>
            <p className="sm-type-body-strong sm-tabular sm-summary-item-price">
              {formatUsd(line.total)}
            </p>
          </div>
          <div className="sm-summary-item-terms">
            <span className="sm-type-caption">{paymentTermsLabel(line)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
